namespace AgerLMS.LMS {
    export interface DiscountGroupsRow {
        Id?: number;
        DiscountId?: number;
        DiscountGroupType?: number;
        DiscountTitle?: string;
        DiscountDiscountType?: number;
        DiscountSource?: number;
        DiscountProductType?: number;
        DiscountPercentage?: number;
        DiscountMaxAmount?: number;
        DiscountMinimumOrder?: number;
        DiscountUsableTimes?: number;
        DiscountCoupon?: string;
        DiscountExpiryDate?: string;
        DiscountOnlyFirst?: number[];
        DiscountInsertDate?: string;
        DiscountInsertUserId?: number;
        DiscountUpdateDate?: string;
        DiscountUpdateUserId?: number;
        DiscountIsActive?: number;
    }

    export namespace DiscountGroupsRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'LMS.DiscountGroups';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            DiscountId = "DiscountId",
            DiscountGroupType = "DiscountGroupType",
            DiscountTitle = "DiscountTitle",
            DiscountDiscountType = "DiscountDiscountType",
            DiscountSource = "DiscountSource",
            DiscountProductType = "DiscountProductType",
            DiscountPercentage = "DiscountPercentage",
            DiscountMaxAmount = "DiscountMaxAmount",
            DiscountMinimumOrder = "DiscountMinimumOrder",
            DiscountUsableTimes = "DiscountUsableTimes",
            DiscountCoupon = "DiscountCoupon",
            DiscountExpiryDate = "DiscountExpiryDate",
            DiscountOnlyFirst = "DiscountOnlyFirst",
            DiscountInsertDate = "DiscountInsertDate",
            DiscountInsertUserId = "DiscountInsertUserId",
            DiscountUpdateDate = "DiscountUpdateDate",
            DiscountUpdateUserId = "DiscountUpdateUserId",
            DiscountIsActive = "DiscountIsActive"
        }
    }
}
